<template>
  <div id="app">
    <Header />
    <Test />
    <Pagination />
   <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Test from '@/components/Test.vue'
import Pagination from '@/components/Pagination.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'App',
  components: {
    Test,
    Pagination,
    Header,
    Footer,
  },
}
</script>

<style>
* {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Roboto Condensed', Helvetica, Arial, sans-serif;
  background-color: #ec7404;
  color: #4a4a4a;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 100%;
  font-size: 16px;
}

#app {
  width: 100%;
  max-width: 700px;
  margin: 50px auto;
}
</style>
